import {Button, IconButton, Tooltip} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {Link} from 'react-router-dom';
import {ReportTemplateCardProps} from '../types/report-list.types';
import styles from '../report-pages.module.scss';

export const ReportTemplateCard = ({
  report,
  editable,
  downloadable,
  busy,
  download,
  onRun,
  onDelete,
}: ReportTemplateCardProps) => {
  const current = download.reportId === report.id;
  const label =
    current && download.phase === 'generating'
      ? 'Формируется…'
      : current && download.phase === 'downloading'
        ? 'Скачивается…'
        : current && download.document
          ? 'Повторить скачивание'
          : 'Сформировать отчёт';
  return (
    <article className={styles.templateCard}>
      <h2>{report.name}</h2>
      <p className={styles.description}>{report.comment || 'Описание не задано'}</p>
      <div className={styles.cardFooter}>
        <span className={styles.visibility}>{report.isPublic ? 'Доступен компании' : 'Личный отчёт'}</span>
        {editable && (
          <div className={styles.cardActions}>
            <Tooltip title="Редактировать">
              <IconButton
                component={Link}
                to={`/reports/builder/${report.id}/edit`}
                size="small"
                disabled={busy}
                aria-label={`Редактировать отчёт «${report.name}»`}
              >
                <EditOutlinedIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Удалить">
              <IconButton
                size="small"
                disabled={busy}
                onClick={() => onDelete(report)}
                aria-label={`Удалить отчёт «${report.name}»`}
              >
                <DeleteOutlineIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          </div>
        )}
      </div>
      <Button
        variant="outlined"
        size="small"
        fullWidth
        disabled={!downloadable || busy}
        onClick={() => onRun(report)}
        sx={{mt: 1.5, textTransform: 'none'}}
        aria-label={`${label}: ${report.name}`}
      >
        {label}
      </Button>
    </article>
  );
};
